import { CreateOrEditSurveyModalComponent } from './surveys/modals/create-or-edit-survey-modal.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableModule, AutoCompleteModule, ToggleButtonModule, InputMaskModule, EditorModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { EventRoutingModule } from '@app/event/event-routing.module';
import { ModalModule, TabsModule, TooltipModule, PopoverModule } from 'ngx-bootstrap';
import { UtilsModule } from '@shared/utils/utils.module';
import { EventsComponent } from '@app/event/events/events.component';
import { EventTypesComponent } from '@app/event/event-types/event-types.component';
import { CreateOrEditEventTypeModalComponent } from '@app/event/event-types/modal/create-or-edit-event-type-modal.component';
import { CreateOrEditEventModalComponent } from '@app/event/events/modals/create-or-edit/create-or-edit-event-modal.component';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FileUploadModule } from 'ng2-file-upload';
import { FileUploadModule as PrimeNgFileUploadModule } from 'primeng/primeng';
import { CouponGroupsComponent } from '@app/event/coupon-groups/coupon-groups.component';
import { CreateOrEditCouponGroupModalComponent } from '@app/event/coupon-groups/modal/create-or-edit-coupon-group-modal.component';
import { SignUpComponent } from '@app/event/sign-up/sign-up.component';
import { RegistrationComponent } from '@app/event/registration/registration.component';
import { EventScheduleComponent } from '@app/event/schedule/event-schedule.component'
import { MyRegistrationsComponent } from '@app/event/my-registrations/my-registrations.component';
import { RegistrationsComponent } from '@app/event/registrations/registrations.component';
import { EventInformationsModalComponent } from '@app/event/event-informations-modal/event-informations-modal.component';
import { DisapproveModalComponent } from '@app/event/registrations/modals/disapprove/disapprove-modal.component';
import { CancelModalComponent } from '@app/event/registrations/modals/cancel/cancel-modal.component';
import { TransferToAnotherUserModalComponent } from '@app/event/registrations/modals/transfer-to-another-user/transfer-to-another-user-modal.component';
import { AdjustDeadlineForPublishModalComponent } from '@app/event/events/modals/adjust-deadline-for-publish/adjust-deadline-for-publish-modal.component';
import { CredentialsComponent } from '@app/event/credentials/credentials.component';
import { CreateOrEditCredentialModalComponent } from '@app/event/credentials/modal/create-or-edit-credential-modal.component';
import { AppModule } from '@app/app.module';
import { TransferToAnotherEventModalComponent } from './registrations/modals/transfer-to-another-event/transfer-to-another-event-modal.component';
import { AnswerComponent } from './surveys/answer/answer.component';
import { DetailModalComponent } from '@app/event/registrations/modals/detail/detail-modal.component';
import { ImportPresenceToRegistrationsModalComponent } from '@app/event/registrations/modals/import-presence-to-registrations/import-presence-to-registrations-modal.component';
import { importType } from '@angular/compiler/src/output/output_ast';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SurveysComponent } from './surveys/surveys.component';
import { ValidateCertificateComponent } from './certificate/validate/validate.component';
import { QrCodeModalComponent } from './surveys/modals/qrcode-modal.component';

@NgModule({
  imports: [

    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    UtilsModule,
    DataTableModule,
    PaginatorModule,
    EventRoutingModule,
    AutoCompleteModule,
    AppCommonModule,
    ToggleButtonModule,
    CurrencyMaskModule,
    FileUploadModule,
    PrimeNgFileUploadModule,
    InputMaskModule,
    EditorModule,
    AppModule,
    InfiniteScrollModule
  ],
  exports: [EventInformationsModalComponent],
  declarations: [
    EventsComponent,
    CreateOrEditEventModalComponent,
    EventTypesComponent,
    CreateOrEditEventTypeModalComponent,
    CouponGroupsComponent,
    CreateOrEditCouponGroupModalComponent,
    MyRegistrationsComponent,
    SignUpComponent,
    RegistrationComponent,
    EventScheduleComponent,
    RegistrationsComponent,
    EventInformationsModalComponent,
    DisapproveModalComponent,
    CancelModalComponent,
    TransferToAnotherUserModalComponent,
    AdjustDeadlineForPublishModalComponent,
    CredentialsComponent,
    CreateOrEditCredentialModalComponent,
    TransferToAnotherEventModalComponent,
    SurveysComponent,
    AnswerComponent,
    CreateOrEditSurveyModalComponent,
    DetailModalComponent,
    ImportPresenceToRegistrationsModalComponent,
    ValidateCertificateComponent,
    QrCodeModalComponent
  ]
  //providers: [ {provide: 'googleTagManagerId', useValue: 'GTM-WR3NBVF'} ]
})
export class EventModule {  }



// WEBPACK FOOTER //
// ./src/app/event/event.module.ts